import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import win10StartLightBackground from './assets/win10-start-light-bgimage.svg';
import { getStartStyles } from './styles/win10-start-light-style';


export const Win10StartLight = ({
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getStartStyles({ styleOverrides }));

  return (
    <div className={classnames('win-start-background', classes.startBackground)}>
      <img className={classnames('win-start-background-image', classes.background)} alt="" src={win10StartLightBackground} />
      <div className={classnames('win-start-ad-container', classes.adContainer)} />
    </div>
  );
};

Win10StartLight.propTypes = {
  styleOverrides: PropTypes.shape({}),
};

Win10StartLight.defaultProps = {
  styleOverrides: {},
};
